import Link from '@material-ui/core/Link';

export const NO_NAMESPACES_FOUND_MESSAGE = 'No namespaces found';

export const hasNoNamespacesFoundError = (error: unknown): boolean =>
  error instanceof Error && error.message.toLowerCase().includes(NO_NAMESPACES_FOUND_MESSAGE.toLowerCase());

export const NamespacesHelperText = (props: { error?: unknown }) => {
  const { error } = props;

  if (!error) return undefined;

  return hasNoNamespacesFoundError(error) ? (
    <span role="alert" aria-live="assertive">
      No vault namespace found for this app. Create a namespace in Secret Vault to continue.{` `}
      <Link
        href="https://developer.aa.com/secret-vault"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Create namespace in Secret Vault (opens in a new tab)"
      >
        Create namespace
      </Link>
    </span>
  ) : (
    <span role="alert" aria-live="assertive">
      Failed to fetch vault namespaces. Please make sure the namespace is created in{` `}
      <Link
        href="https://developer.aa.com/secret-vault"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Secret Vault (opens in a new tab)"
      >
        Secret Vault
      </Link>
      {` `}
      and you have access
    </span>
  );
};
